import cart from '@ppcp/cart';
import order from '@ppcp/order';
import {getSetting, getPage} from '@ppcp/utils';
import {CheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import GooglePayGateway from '../gateways/GooglePayGateway';
import {registerPaymentMethod} from '@ppcp/payment-methods';

const settings = getSetting('ppcp_googlepay_data');

const gateway = new GooglePayGateway({
    id: 'ppcp_googlepay',
    cart,
    settings
});

const controller = new CheckoutController({
    id: 'ppcp_googlepay',
    cart,
    order,
    context: new Context(getPage()),
    gateway,
    settings
});

registerPaymentMethod(gateway);

controller.initialize();